import type { UpdatePropertyInput } from '@/backend/types'
import { exhaustiveGuard } from '@/shared/utils/typeAssertions'
import { isEmptyObject } from '@/shared/utils/typeGuards'
import type { PropertyInput } from './types'

/**
 * Serializes frontend PropertyInput to API format
 */
export function deserializePropertyInput(input: PropertyInput): UpdatePropertyInput {
  if (input.type === 'directHub') {
    return {
      direct_hub_id: input.directHubId,
    }
  } else if (input.type === 'directField') {
    return {
      entity_id: input.entityId,
      property_id: input.propertyId,
    }
  } else if (input.type === 'viaReference') {
    return {
      property_id: input.propertyId,
      via_property_id: input.viaPropertyId,
      entities_filter: isEmptyObject(input.filters) ? undefined : input.filters || undefined,
    }
  } else if (input.type === 'related') {
    return {
      property_id: input.propertyId,
      entities_filter: isEmptyObject(input.filters) ? undefined : input.filters || undefined,
    }
  } else {
    return exhaustiveGuard(input, `Unknown input type: ${JSON.stringify(input)}`)
  }
}

/**
 * Serializes an array of frontend PropertyInputs to API format
 */
export function serializePropertyInputs(inputs: PropertyInput[]): UpdatePropertyInput[] {
  return inputs.map(deserializePropertyInput)
}
